export interface StatusBadgeConfig {
  label: string;
  className: string;
}

const serviceStatusMap: Record<string, StatusBadgeConfig> = {
  active: {
    label: "Active",
    className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20",
  },
  pending_cancellation: {
    label: "Pending Cancel",
    className: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  },
  cancelled: {
    label: "Cancelled",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
};

const renewalStatusMap: Record<string, StatusBadgeConfig> = {
  pending: {
    label: "Pending",
    className: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  },
  emailed: {
    label: "Emailed",
    className: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20",
  },
  paid: {
    label: "Paid",
    className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20",
  },
  failed: {
    label: "Failed",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
  voided: {
    label: "Voided",
    className: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
  },
  cancelled: {
    label: "Cancelled",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
};

const emailStatusMap: Record<string, StatusBadgeConfig> = {
  sent: {
    label: "Sent",
    className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20",
  },
  failed: {
    label: "Failed",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
};

const ticketStatusMap: Record<string, StatusBadgeConfig> = {
  new: {
    label: "New",
    className: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20",
  },
  in_progress: {
    label: "In Progress",
    className: "bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/20",
  },
  pending: {
    label: "Pending",
    className: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  },
  closed: {
    label: "Closed",
    className: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
  },
  spam: {
    label: "Spam",
    className: "bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/20",
  },
  deleted: {
    label: "Deleted",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
};

const priorityMap: Record<string, StatusBadgeConfig> = {
  P1: {
    label: "P1 Critical",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
  P2: {
    label: "P2 High",
    className: "bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/20",
  },
  P3: {
    label: "P3 Medium",
    className: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  },
  P4: {
    label: "P4 Low",
    className: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
  },
};

const workRequestStatusMap: Record<string, StatusBadgeConfig> = {
  draft: {
    label: "Draft",
    className: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
  },
  submitted: {
    label: "Submitted",
    className: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20",
  },
  ticket_created: {
    label: "Ticket Created",
    className: "bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/20",
  },
  completed: {
    label: "Completed",
    className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20",
  },
  cancelled: {
    label: "Cancelled",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
};

const kbReviewStatusMap: Record<string, StatusBadgeConfig> = {
  active: {
    label: "Active",
    className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20",
  },
  pending: {
    label: "Pending Review",
    className: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  },
  rejected: {
    label: "Rejected",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
};

const invoiceStatusMap: Record<string, StatusBadgeConfig> = {
  draft: {
    label: "Draft",
    className: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
  },
  pending: {
    label: "Pending",
    className: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  },
  approved: {
    label: "Approved",
    className: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20",
  },
  paid: {
    label: "Paid",
    className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20",
  },
  voided: {
    label: "Voided",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
};

const xeroSyncStatusMap: Record<string, StatusBadgeConfig> = {
  not_synced: {
    label: "Not Synced",
    className: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
  },
  queued: {
    label: "Queued",
    className: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/20",
  },
  synced: {
    label: "Synced",
    className: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/20",
  },
  failed: {
    label: "Failed",
    className: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/20",
  },
};

const statusMaps: Record<string, Record<string, StatusBadgeConfig>> = {
  service: serviceStatusMap,
  renewal: renewalStatusMap,
  email: emailStatusMap,
  ticket: ticketStatusMap,
  priority: priorityMap,
  workRequest: workRequestStatusMap,
  kbReview: kbReviewStatusMap,
  invoice: invoiceStatusMap,
  xero: xeroSyncStatusMap,
};

const fallback: StatusBadgeConfig = {
  label: "Unknown",
  className: "bg-gray-500/10 text-gray-700 dark:text-gray-400 border-gray-500/20",
};

export function getStatusBadgeConfig(
  type: string,
  status: string,
): StatusBadgeConfig {
  const map = statusMaps[type];
  if (!map) return { ...fallback, label: status };
  return map[status] ?? { ...fallback, label: status };
}
